<span>{{discoverBrandsText}}</span>
